module.exports = __webpack_public_path__ + "static/img/visibility-24px.8142a043.svg";